module.exports = __webpack_public_path__ + "img/blog-10.5803cf8c.jpg";